import React from "react";
import { Row, Col, Form, Card } from "react-bootstrap";

import InputComponent from "../InputComponent/InputComponent";
import Dropdown from "../Dropdown/Dropdown";
import ButtonComponent from "../ButtonComponent/ButtonComponent";

import "./SearchComponent.css";

import "./SearchComponent.css";

const SearchComponent = (props) => {
  return (
    <>
      {" "}
      <div className="mb-4">
        <Row className="justify-content-center">
          <Col lg={7} md={12} className="align-self-center">
            <Card style={{ border: props.borderStyle }}>
              <Card.Body>
                <Card.Title>Pretraga zahtjeva</Card.Title>

                <Form className="searchform" onSubmit={props.onSubmit}>
                  <div>
                    <InputComponent
                      onChange={props.searchHandler}
                      value={props.searchValue}
                      id="searchText"
                      placeholder={
                        "Unesite OIB, registarski broj, ime, prezime, naziv subjekta ili klasu "
                      }
                      controlLabel="OIB, registarski broj, ime, prezime, naziv subjekta ili klasa"
                    />
                  </div>

                  <Dropdown
                    label={"Odaberite status"}
                    onChange={props.statusDropdownHandler}
                    value={props.dropdownValue}
                    asProperty="select"
                    map={props.statusOptions}
                    text="SVI STATUSI"
                    id={"status"}
                  />

                  <Dropdown
                    label={props.dropdownLabel}
                    onChange={props.valueDropdownHandler}
                    value={props.formValue}
                    asProperty="select"
                    map={props.formOptions}
                    text={props.text}
                    id="registar/zahtjev"
                  />
                  <Row>
                    <Col>
                      <ButtonComponent
                        variant="primary"
                        type="submit"
                        className="search-button"
                        block
                        loading={props.isLoading ? true : false}
                      >
                        Pretraga
                      </ButtonComponent>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SearchComponent;
